import { render, staticRenderFns } from "./LastStep.vue?vue&type=template&id=634ed836&scoped=true&"
import script from "./LastStep.vue?vue&type=script&lang=js&"
export * from "./LastStep.vue?vue&type=script&lang=js&"
import style0 from "./LastStep.vue?vue&type=style&index=0&id=634ed836&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ed836",
  null
  
)

export default component.exports